import { Box, Checkbox } from '@mui/material'
import Menu, { MenuProps } from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import { ReactComponent as CrossCloseLogo } from 'assets/cross_close_logo.svg'
import CheckBoxActive from 'assets/icons/checkBoxActive'
import settingsIcon from 'assets/Settingsx.png'
import { ColumnTypes } from 'models'
import { useState } from 'react'
import { COLORS } from 'styles/colors'
import CustomButton from 'ui/buttons/CustomButton'
import TooltipHover from 'ui/TooltipHover'
import { ReactComponent as CheckBox } from '../../../../../assets/icons/checkBox.svg'

const icon = <CheckBox />
const checkedIcon = <CheckBoxActive />
const StyledMenu = styled((props: MenuProps) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}
		{...props}
	/>
))(({ theme }) => ({
	'& .MuiPaper-root': {
		borderRadius: 8,
		marginTop: theme.spacing(1),
		minWidth: 210,
		color:
			theme.palette.mode === 'light'
				? 'rgb(55, 65, 81)'
				: theme.palette.grey[300],
		boxShadow: '0px 0px 16px 0px #04060629',
		'& .MuiMenu-list': {
			padding: '8px',
		},
		'& .MuiMenuItem-root': {
			margin: '4px',
			'& .MuiSvgIcon-root': {
				fontSize: 18,
				color: theme.palette.text.secondary,
				marginRight: theme.spacing(1.5),
			},
			'&:active': {
				backgroundColor: 'transparent',
			},
		},
	},
}))

type ColumnsMenuProps = {
	activeColumns: ColumnTypes[]
	onClick: (title: string) => void
	isDefaultView?: boolean
	onResetView?: () => void
	minSelected?: number
	maxSelected?: number
}

export default function AddColumnMenu(props: ColumnsMenuProps) {
	const {
		activeColumns,
		onClick,
		isDefaultView = true,
		onResetView,
		minSelected = 1,
		maxSelected,
	} = props
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	const selectedCount = activeColumns.filter(col => col.isShowColumn).length

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}

	const handleToggle = (column: ColumnTypes) => {
		if (column.isShowColumn && selectedCount <= minSelected) return
		if (
			!column.isShowColumn &&
			maxSelected != null &&
			selectedCount >= maxSelected
		) {
			return
		}
		onClick(column.title)
	}

	return (
		<Box display='flex' alignItems='center' gap='8px'>
			<TooltipHover
				title='Добавить/убрать столбцы в таблице'
				placement='top-start'
				disableHoverBackground
			>
				<CustomButton
					title='Вид таблицы'
					onClick={handleClick}
					iconElement={
						<img
							src={settingsIcon}
							alt=''
							style={{ width: 20, height: 20, display: 'block' }}
						/>
					}
					colors={[COLORS.main, COLORS.main]}
				/>
			</TooltipHover>
			{!isDefaultView && onResetView && (
				<CrossCloseLogo
					onClick={onResetView}
					style={{
						width: '16px',
						height: '16px',
						cursor: 'pointer',
						stroke: COLORS.secondary,
					}}
				/>
			)}
			<StyledMenu
				id='lameness-column-customized-menu'
				MenuListProps={{
					'aria-labelledby': 'demo-customized-button',
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				{activeColumns.map((el, index) => {
					const disableUncheck = el.isShowColumn && selectedCount <= minSelected
					const disableCheck =
						!el.isShowColumn &&
						maxSelected != null &&
						selectedCount >= maxSelected

					return (
						<MenuItem
							key={index}
							onClick={() => handleToggle(el)}
							disableRipple
							disabled={disableUncheck || disableCheck}
							sx={{
								color: COLORS.secondaryFont,
								fontSize: '14px',
								padding: '0px',
								'&:hover': {
									backgroundColor: '#fff',
								},
								'&.Mui-selected': {
									backgroundColor: '#fff',
									color: '#fff',
								},
							}}
						>
							<Checkbox
								icon={icon}
								disableRipple
								checkedIcon={checkedIcon}
								style={{ padding: '0px 10px 0px 0px', margin: '0px' }}
								checked={el.isShowColumn}
								disabled={disableUncheck || disableCheck}
							/>
							{el.title}
						</MenuItem>
					)
				})}
			</StyledMenu>
		</Box>
	)
}
